'use client';
import type { FlexibleFormVariant } from './FlexibleFormBase';
import { hasRichTextContent } from '@/packages/richText/utils';
import { createDefaultFlexibleFormVariant } from './FlexibleFormDefaultVariant';
import { createPromoCodeEntryVariant } from './FlexibleFormPromoCodeEntryVariant';
import { createFlepzVariant } from './FlexibleFormFlepzVariant';
import { createWidgetFormLayoutConfig } from './WidgetForm';
import { getFlexibleFormAlignment } from './flexibleFormVariantHelpers';
import { EmailHandoffProgress } from './EmailHandoffProgress';
import { EMAIL_HANDOFF_FORM_TYPE } from './emailHandoffConfig';

interface FlexibleFormLayoutConfigArgs {
    asset: SiteFlexibleForm;
    nestedForm: boolean;
    toggleForm: boolean;
}

export function createFlexibleFormLayoutConfig({
    asset,
    nestedForm,
    toggleForm,
}: FlexibleFormLayoutConfigArgs): Pick<FlexibleFormVariant, 'styles' | 'submitButtonFitting' | 'renderContent'> {
    const formType = asset.fields.type.toLowerCase();
    const alignment = getFlexibleFormAlignment(asset);
    const hasHeadlineContent = hasRichTextContent(asset.fields.headline);
    const variantFactoryArgs = {
        asset,
        nestedForm,
        toggleForm,
        hasHeadlineContent,
        alignment,
        headerEyebrow: formType === EMAIL_HANDOFF_FORM_TYPE ? <EmailHandoffProgress /> : undefined,
    };

    if (formType === 'promocodeentry') {
        return createPromoCodeEntryVariant(variantFactoryArgs);
    }

    if (formType === 'widgetform-nflsignup') {
        return createWidgetFormLayoutConfig(asset);
    }

    if (formType === 'widgetform-flepz') {
        return createFlepzVariant(variantFactoryArgs);
    }

    return createDefaultFlexibleFormVariant(variantFactoryArgs);
}
